var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import isEmpty from 'lodash.isempty';
import { useMemo } from 'react';
import useDesign from '../../../hooks/useDesign';
import { IconText } from '../../molecules/IconText';
import { Incentive } from './components/Incentive';
import { Wrapper } from './styles';
import { prepareMergedIncentives } from './utils';
export var Incentives = function (_a) {
    var design = _a.design, commercialIncentives = _a.commercialIncentives, evaluationsIncentives = _a.evaluationsIncentives;
    var _b = useDesign(design), components = _b.components, schema = _b.schema;
    var _c = useMemo(function () { return prepareMergedIncentives(evaluationsIncentives, commercialIncentives); }, [commercialIncentives, evaluationsIncentives]), eligible = _c.eligible, ineligible = _c.ineligible, rest = _c.rest;
    return (_jsxs(Wrapper, __assign({ schema: schema, "data-design": design }, { children: [!isEmpty(eligible) && _jsx(IconText, { design: components.eligibleDialog }), eligible.map(function (incentive) { return (_jsx(Incentive, { values: incentive, design: components.incentive }, incentive.handle)); }), (!isEmpty(ineligible) || !isEmpty(rest)) && (_jsx(IconText, { design: components.ineligibleDialog })), __spreadArray(__spreadArray([], ineligible, true), rest, true).map(function (incentive) { return (_jsx(Incentive, { values: incentive, design: components.incentive }, incentive.handle)); })] })));
};
Incentives.displayName = 'Incentives';
